import React from 'react';
import { Controller } from 'react-hook-form';
import FormItem from '../formItem';
import { Input } from 'antd';
import styled from 'styled-components';

const LoginForm = ({
	formProps: {
		control,
		formState: { errors },
	},
}) => {
	return (
		<div>
			<FormItem label="Username" error={errors?.username?.message}>
				<Controller
					name="username"
					control={control}
					render={({ field }) => <Input placeholder="Enter your username" {...field} />}
				/>
			</FormItem>
			<FormItem label="Password" error={errors?.password?.message}>
				<Controller
					name="password"
					control={control}
					render={({ field }) => <InputPass placeholder="Enter your password" {...field} />}
				/>
			</FormItem>
		</div>
	);
};

export default LoginForm;

const InputPass = styled(Input.Password)`
	.ant-input {
		border: unset !important;
		box-shadow: unset !important;
		-webkit-box-shadow: unset !important;
	}
	border-radius: 5px !important;
`;
